
//******************Exchange Rate Server Calls******************;

import { PreviousCouponsActions } from './GetCouponTermsConstants';
import store from '../../../Store/store'
import {ROOT_URL,getCookie} from '../../../Config/Config';
import {failure_messages} from "Messages"

export const PreviousCouponsServer = {
  //  GetCouponTerms:GetCouponTerms,
  GetCouponTerms: GetCouponTerms,
  //  updateGetCouponTerms:updateGetCouponTerms
};

//****************** GetCouponTerms with coupons ******************;

//****************** This Api fetch the Quotas of bussiness Id along with total coupons already generated; grouped by all the years of the contract.

function GetCouponTerms() {

  const request = fetch(ROOT_URL + '/api/coupons/getCouponTerms', {
    method: 'Post',
    mode: 'cors',
    headers: { 
      'authorization':getCookie("admin_token_partner"),
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
  }).then((response) => {
    response.json().then(response => {
      if (response.status == "200") {
        // console.log('Business quota details', response.data)

  //****************** responce.data contains values of business Quotas along with business crontact
  //****************** responce.CouponFaceValues contains count of generated coupon based on business_id and year_id
        store.dispatch({ type: PreviousCouponsActions.GetCouponTerms_GET.SUCCESS, payload: response.data});
        return;
      } else {
        store.dispatch({ type: PreviousCouponsActions.GetCouponTerms_GET.FAILED, error:response.error });
        return;
      }
    }).catch((error) => {
      store.dispatch({ type: PreviousCouponsActions.GetCouponTerms_GET.FAILED, error:failure_messages.unExpectedError });
    })
  }).catch((error) => {
    store.dispatch({ type: PreviousCouponsActions.GetCouponTerms_GET.FAILED, error:failure_messages.unExpectedError });
  })
  return { type: PreviousCouponsActions.GetCouponTerms_GET.LOADING }

};
